/* ============================================================
   TAPP'D — Route A
   Small, dependency-free. Everything degrades without JS.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- mobile menu ------------------------------------------------ */
  function initMenu(root) {
    var btn = root.querySelector('[data-menu-toggle]');
    var nav = root.querySelector('[data-menu]');
    if (!btn || !nav) return;

    btn.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('open')) {
        nav.classList.remove('open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  }

  /* ---- scroll reveal ---------------------------------------------- */
  function initReveal() {
    var items = document.querySelectorAll('.rv:not(.in)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (!entry.isIntersecting) return;
        entry.target.style.transitionDelay = (i * 60) + 'ms';
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el) { io.observe(el); });
  }

  /* ---- marquee ----------------------------------------------------
     The track is duplicated in Liquid so the -50% keyframe loops
     seamlessly. If motion is reduced, drop the clone so screen
     readers and the page don't carry the text twice. */
  function initMarquee() {
    if (!reduceMotion) return;
    document.querySelectorAll('[data-marquee-clone]').forEach(function (clone) {
      clone.remove();
    });
  }

  function init() {
    document.querySelectorAll('[data-header]').forEach(initMenu);
    initReveal();
    initMarquee();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when the theme editor swaps a section in */
  document.addEventListener('shopify:section:load', init);
})();
